import { TamboAIError } from "@tambo-ai/typescript-sdk";

export class ThreadInputError extends TamboAIError {}
